import NumberFormat from 'react-number-format';

export const FormattedText = ({ children: value, format }: any) => {
  if (!format) {
    return value;
  }

  return <NumberFormat {...{ value, ...format }} displayType="text" />;
};
